<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="full-width"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Alcances Acreditados</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
        selectedUrl
            ? `/accreditations/officio/storeChecked/${inputs.id}`
            : `/accreditations/officio/storeChecked`
        "
      >
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OINSP'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Sector</th>
              <th scope="col">Campo de inspección/alcance</th>
              <th scope="col">Elemento a inspeccionar</th>
              <th scope="col">Tipo de inspección o metodología</th>
              <th scope="col">
                Tipo de Organismo en base a la independencia (A,B,C)
              </th>
              <th scope="col">Procedimientos de Inspección</th>
              <th scope="col">
                Código tipo de la norma o especificación técnica/Vigencia de la
                norma o especificación técnica (Año de publicación,
                reafirmación, edición/revisión (cuando aplique))
              </th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_4_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_5_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                {{ scope.level_6.value }}
              </td>
              <td class="align-middle">
                <span v-html="scope.level7"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level8"></span>
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OEYC'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Organización</th>
              <th scope="col">Categoría</th>
              <th scope="col">Campo de calibración</th>
              <th scope="col">Magnitud y Submagnitud</th>
              <th scope="col">Rango de Medida</th>
              <th scope="col">Incertidumbre</th>
              <th scope="col">Instrumentos</th>
              <th scope="col">Método Interno</th>
              <th scope="col">Método Referencia (revisión/edición)</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                Matriz
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_5.value }}
              </td>
              <td class="align-middle">
                <span v-html="scope.level7"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level8"></span>
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_6_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level9"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level10"></span>
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OCLN'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Ubicación</th>
              <th scope="col">Categoría</th>
              <th scope="col">Campo de Análisis</th>
              <th scope="col">Muestra</th>
              <th scope="col">Análisis</th>
              <th scope="col">Técnica</th>
              <th scope="col">Método de Análisis</th>
              <th scope="col">Procedimiento</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                Matriz
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_7_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                {{ scope.level_6.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_5.value }}
              </td>
              <td class="align-middle">
                <span v-html="scope.level9"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level10"></span>
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OICC'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Ubicación</th>
              <th scope="col">Categoría</th>
              <th scope="col">Campo de Ensayo</th>
              <th scope="col">Grupo de Productos</th>
              <th scope="col">Ensayo</th>
              <th scope="col">Técnica</th>
              <th scope="col">Método Interno</th>
              <th scope="col">Método Referencia</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                Matriz
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_7_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                {{ scope.level_6.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_5.value }}
              </td>
              <td class="align-middle">
                <span v-html="scope.level9"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level10"></span>
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OEAP'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Sector</th>
              <th scope="col">Nombre del Programa (1)</th>
              <th scope="col">Ensayo / Magnitud G(2)</th>
              <th scope="col">Ítem de Ensayo de Aptitud (3)</th>
              <th scope="col">Frecuencia (4)</th>
              <th scope="col">Método Para Establecer el Valor Asignado (5)</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                <span v-html="scope.level7"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level8"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level9"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level10"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level11"></span>
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OENY'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Organización</th>
              <th scope="col">Categoría</th>
              <th scope="col">Campo</th>
              <th scope="col">Producto</th>
              <th scope="col">Técnica</th>
       <th scope="col">Ensayo</th>
              <th scope="col">Rango</th>
              <th scope="col">Método Interno</th>
              <th scope="col">Método Referencia (revisión/edición)</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                Matriz
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_7_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                {{ scope.level_5.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_6.value }}
              </td>
              <td class="align-middle">
                <span v-html="scope.level8"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level9"></span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level10"></span>
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OCSG'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Sector</th>
              <th scope="col">Norma de acreditación</th>
              <th scope="col">Norma de certificación</th>
              <th scope="col">Sector IAF</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_5.value }}
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OCPE'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Sector</th>
              <th scope="col">Norma de acreditación</th>
              <th scope="col">Personal certificado</th>
              <th scope="col">Categoría de personal</th>
              <th scope="col">Documento normativo</th>
              <th scope="col">Esquema de certificaciòn de personas</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_5_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                {{ scope.level_6.value }}
              </td>
              <td class="align-middle">
                <span v-html="scope.level7"></span>
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OCPR'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Sector</th>
              <th scope="col">Norma de acreditación</th>
              <th scope="col">Producto, Proceso o Servicio</th>
              <th scope="col">Categoría de producto, Proceso o Servicio</th>
              <th scope="col">Documento normativo</th>
              <th scope="col">Modificatorias a los Documentos Normativos</th>
              <th scope="col">Tipo de esquema de certificación</th>
              <th scope="col">Especificación técnica</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_5_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_6_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level7"></span>
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_8_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                <span v-html="scope.level9"></span>
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['CSIA'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Sector</th>
              <th scope="col">Norma de acreditación</th>
              <th scope="col">Norma de certificación</th>
              <th scope="col">Grupo</th>
              <th scope="col">Categoría</th>
              <th scope="col">Subcategoría</th>
              <th scope="col">Documento normativo específico para FSSC</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_5.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_6.value }}
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_7_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                {{ scope.level_8b.value }}
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['CSA'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Sector</th>
              <th scope="col">Norma de acreditación</th>
              <th scope="col">Norma de certificación</th>
              <th scope="col">Sector IAF</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_5.value }}
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['CSGAS'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Sector</th>
              <th scope="col">Norma de acreditación</th>
              <th scope="col">Norma de certificación</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['CSDM'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Sector</th>
              <th scope="col">Norma de acreditación</th>
              <th scope="col">Norma de certificación</th>
              <th scope="col">Sector/Referencia</th>
              <th scope="col">Actividad</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_5.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_6.value }}
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OVV'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Actividad</th>
              <th scope="col">Categoría</th>
              <th scope="col">Programa</th>
              <th scope="col">Documento Normativo</th>
              <th scope="col">Sector</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scope, key) in scopes" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="scope.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ scope.level_2.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_3.value }}
              </td>
              <td class="align-middle">
                {{ scope.level_4.value }}
              </td>
              <td class="align-middle">
                <span v-for="(val, key) in scope.level_5_selected" :key="key">
                  {{ 
                    `${val.scope_master.description}`
                  }}<br>
                </span>
              </td>
              <td class="align-middle">
                {{ scope.level_6.value }}
              </td>
              <td class="align-middle">
                <span class="badge badge-sm badge-pill badge-primary">{{scope.condicion_scopes.name}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit" v-if="showSave">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "@/app/helpers/AxiosHelper";

export default {
  name: "OfficioScopesModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    activity: String,
    activityId: Number,
    userId: Number,
    accAppId: String,
  },
  data() {
    return {
      preloader: false,
      modalId: "officio-scopes-modal",
      scopes: {},
      showSave: false,
    };
  },
  created() {
    this.dataInfo();
  },
  methods: {
    submit() {
      let i = 0;
      this.scopes = this.scopes.map((scope) => {
        return {
          ...scope, 
          is_checked: scope.is_checked ? 1 : 0, 
        };
      });
      // this.scopes.forEach((item) => {  
      //   if (item.is_checked) i++;
      //   // item.is_checked ? 1 : 0;
      // });
      // if (i == 0) {
      //   this.$toastr.e(
      //     "Debe seleccionar por lo menos un alcance para guardar"
      //   );
      //   return;
      // }
      this.save({ scopes: this.scopes, accAppId: this.accAppId, activityId: this.activityId });
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("created_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },
    dataInfo() {
      this.preloader = true;
      axiosGet(
        `/accreditations/officio/showScope/${this.userId}?activityId=${this.activityId}&&accAppId=${this.accAppId}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.scopes = response.data;

            this.scopes = this.scopes.map((scope) => {
              if (scope.status_id == 98) {
                return {
                ...scope, 
                is_checked: 1, 
              };
              } else {
                return {
                ...scope, // Copia todas las propiedades existentes en el objeto scope
                is_checked: 0, // Agrega la propiedad is_checked con el valor inicial false
              };
              }
            });

            if (response.data.length > 0) {
              this.showSave = true;
            }
            
          }
        
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>

<style>
</style>
